import { createComposer } from '@/lib/create-composer'
import type { WhatsappRecipientType } from './whatsapp.types'
import { WhatsappComposerDialog } from './components/whatsapp-composer-dialog'

// A recipient handed to the composer (e.g. from a profile "Enviar WhatsApp").
export interface WhatsappComposerRecipient {
  type: WhatsappRecipientType
  id?: string
  name: string
  // Nombre de pila, para la variable {{nombre}} de las plantillas.
  firstName?: string
  phone: string // international, '' when unknown
  // True when the number is already confirmed on WhatsApp — the composer then
  // skips re-checking it.
  verified?: boolean
}

export interface OpenWhatsappOptions {
  recipient?: WhatsappComposerRecipient
  body?: string
}

const { Provider, useComposer } = createComposer<OpenWhatsappOptions>(
  WhatsappComposerDialog,
  'useWhatsappComposer',
)

export const WhatsappComposerProvider = Provider

// Open the shared WhatsApp dialog with a recipient (+ optional prefilled body).
export function useWhatsappComposer() {
  const { open } = useComposer()
  return { openWhatsapp: open }
}
